import { useState, useCallback } from 'react'
import { adminApi } from '../api/adminApi'
import type { Post, PaginatedResponse, PostsQueryOptions } from '../types'
import { toast } from '../store/adminStore'

export function usePosts() {
  const [data, setData]       = useState<PaginatedResponse<Post> | null>(null)
  const [loading, setLoading] = useState(false)

  const fetch = useCallback(async (opts: PostsQueryOptions = {}) => {
    setLoading(true)
    try {
      const result = await adminApi.listPosts(opts)
      setData(result)
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Failed to load posts')
    } finally {
      setLoading(false)
    }
  }, [])

  const deletePost = useCallback(async (slug: string): Promise<boolean> => {
    try {
      await adminApi.deletePost(slug)
      toast.success(`Post "${slug}" deleted.`)
      return true
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Delete failed')
      return false
    }
  }, [])

  return { data, loading, fetch, deletePost }
}
